import http from 'utils/http';
import type { QuickLinkCategoryPayload, QuickLinkPayload } from 'interface/link';
import type { ServiceId, ServicePayload } from 'interface/service';

import { interpolate } from 'utils/string';

import {
  DASHBOARD_QUICK_LINKS,
  QUICK_LINK,
  QUICK_LINKS,
  QUICK_LINKS_CATEGORIES,
  QUICK_LINKS_CATEGORY,
  QUICK_LINKS_WEIGHTS,
} from 'constants/endpoints';

/**
 *
 * @returns {Array} quick links
 */
export async function fetchQuickLinks() {
  const data = await http.get(DASHBOARD_QUICK_LINKS);

  return data.data;
}

/**
 *
 * @param {Object} params - query string(s)
 * @returns {Array} quick links
 */
export async function addQuickLinksCategory(category: QuickLinkCategoryPayload) {
  const data = await http.post(QUICK_LINKS_CATEGORIES, { body: category });

  return data;
}

/**
 *
 * @param {Object} params - query string(s)
 * @returns {Array} quick links
 */
export async function updateQuickLinksCategory(id: ServiceId, category: QuickLinkCategoryPayload) {
  const url = interpolate(QUICK_LINKS_CATEGORY, { id });
  const data = await http.put(url, { body: category });

  return data;
}

/**
 *
 * @param {Object} params - id string(s)
 * @returns {Array} quick links
 */
export async function deleteQuickLinksCategory(id: ServiceId) {
  const url = interpolate(QUICK_LINKS_CATEGORY, { id });
  const data = await http.delete(url);

  return data;
}

/**
 *
 * @param {Object} params - query string(s)
 * @returns {Array} quick links
 */
export async function addQuickLinks(link: QuickLinkPayload) {
  const data = await http.post(QUICK_LINKS, { body: link });

  return data;
}

/**
 *
 * @param {Object} params - query string(s)
 * @returns {Array} quick links
 */
export async function updateQuickLinks(id: ServiceId, link: QuickLinkPayload) {
  const url = interpolate(QUICK_LINK, { id });
  const data = await http.put(url, { body: link });

  return data;
}

/**
 *
 * @param {Object} params - id string(s)
 * @returns {Array} quick links
 */
export async function deleteQuickLinks(id: ServiceId) {
  const url = interpolate(QUICK_LINK, { id });
  const data = await http.delete(url);

  return data;
}

export async function updateLinkLibraryWeights(payload: ServicePayload) {
  const url = QUICK_LINKS_WEIGHTS;
  const data = await http.patch(url, { body: payload });

  return data;
}
